import { createBrowserHistory } from "history";
const history = createBrowserHistory();
export {
  history as default
};
//# sourceMappingURL=CreateHistory.js.map
